import { HIDE_TABBAR_PARAM } from '../../../constant';
import { addUrlParam } from '../../../utils/addUrlParam';
import { buildUrlWithParams } from '../../../utils/buildUrlWithParams';

export const addHideTabbarParam = (url: string): string => {
    // добвляем параметр для скрытия таббара
    const urlWithHideTabbarParam = addUrlParam(url, HIDE_TABBAR_PARAM, '1');

    // добавляем текущие параметры урла
    return buildUrlWithParams(urlWithHideTabbarParam);
};
